import React, { useEffect, useState } from 'react';
import { db, storage } from './firebase';
import { collection, addDoc, deleteDoc, doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export default function BuyMusicAdmin() {
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newGenre, setNewGenre] = useState({ name: '', order: 0, coverUrl: '', defaultPrice: '' });
  // Stato per tracce per genere non utilizzato qui; ogni blocco tracce gestisce i propri dati

  useEffect(() => {
    // Legge tutti i generi senza orderBy per includere anche i documenti storici senza createdAt
    const unsub = onSnapshot(collection(db, 'buyGenres'), (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      // Ordine in memoria: createdAt asc, fallback a name/id
      list.sort((a, b) => {
        const ams = a.createdAt?.toMillis ? a.createdAt.toMillis() : (a.createdAt?.seconds ? a.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        const bms = b.createdAt?.toMillis ? b.createdAt.toMillis() : (b.createdAt?.seconds ? b.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        if (ams !== bms) return ams - bms;
        const an = (a.name || '').localeCompare(b.name || '');
        if (an !== 0) return an;
        return (a.id || '').localeCompare(b.id || '');
      });
      setGenres(list);
    });
    return () => unsub();
  }, []);

  const createGenre = async () => {
    if (!newGenre.name.trim()) return alert('Inserisci un nome genere');
    try {
      setLoading(true);
      // parse default price (accetta virgola)
      let dp = null;
      if (newGenre.defaultPrice !== undefined && newGenre.defaultPrice !== null && String(newGenre.defaultPrice).trim() !== '') {
        const parsed = parseFloat(String(newGenre.defaultPrice).replace(',', '.'));
        dp = Number.isFinite(parsed) ? parsed : null;
      }
      await addDoc(collection(db, 'buyGenres'), {
        name: newGenre.name.trim(),
        order: Number(newGenre.order) || 0,
        coverUrl: newGenre.coverUrl || '',
        defaultPrice: dp,
        createdAt: serverTimestamp()
      });
      setNewGenre({ name: '', order: 0, coverUrl: '', defaultPrice: '' });
    } catch (e) {
      console.error('Errore creazione genere', e);
      alert('Errore creazione genere');
    } finally {
      setLoading(false);
    }
  };

  const uploadGenreCover = async (file, gid) => {
    if (!file) return;
    try {
      const r = ref(storage, `buy/genres/${gid}_${Date.now()}_${file.name}`);
      await uploadBytes(r, file);
      const url = await getDownloadURL(r);
      await setDoc(doc(db, 'buyGenres', gid), { coverUrl: url }, { merge: true });
    } catch (e) {
      console.error('Errore upload cover genere', e);
      alert('Errore upload cover');
    }
  };

  const saveGenre = async (g) => {
    try {
      let dp = null;
      if (g.defaultPrice !== undefined && g.defaultPrice !== null && String(g.defaultPrice).trim() !== '') {
        if (typeof g.defaultPrice === 'number' && !Number.isNaN(g.defaultPrice)) {
          dp = g.defaultPrice;
        } else {
          const parsed = parseFloat(String(g.defaultPrice).replace(',', '.'));
          dp = Number.isFinite(parsed) ? parsed : null;
        }
      }
      await setDoc(doc(db, 'buyGenres', g.id), {
        name: g.name || '',
        order: Number(g.order) || 0,
        coverUrl: g.coverUrl || '',
        defaultPrice: dp
      }, { merge: true });
      alert('Genere aggiornato');
    } catch (e) {
      console.error('Errore salvataggio genere', e);
      alert('Errore salvataggio genere');
    }
  };

  const deleteGenre = async (gid) => {
    if (!window.confirm('Eliminare definitivamente questo genere? (Le tracce nel sottolivello resteranno orfane)')) return;
    try {
      await deleteDoc(doc(db, 'buyGenres', gid));
    } catch (e) {
      console.error('Errore eliminazione genere', e);
    }
  };

  const addTrack = async (gid, defaultPrice) => {
    const title = prompt('Titolo brano:');
    if (!title) return;
    try {
      await addDoc(collection(db, 'buyGenres', gid, 'tracks'), {
        title: title.trim(),
        order: 0,
        audioUrl: '',
        paymentLinkUrl: '',
        paypalLinkUrl: '',
        downloadLink: '',
        sold: false,
        price: (typeof defaultPrice === 'number' && !Number.isNaN(defaultPrice)) ? defaultPrice : null,
        createdAt: serverTimestamp()
      });
    } catch (e) {
      console.error('Errore creazione brano', e);
      alert('Errore creazione brano');
    }
  };

  const uploadTrackAudio = async (gid, tid, file) => {
    if (!file) return;
    try {
      const r = ref(storage, `buy/tracks/${gid}_${tid}_${Date.now()}_${file.name}`);
      await uploadBytes(r, file);
      const url = await getDownloadURL(r);
      await setDoc(doc(db, 'buyGenres', gid, 'tracks', tid), { audioUrl: url }, { merge: true });
    } catch (e) {
      console.error('Errore upload audio brano', e);
      alert('Errore upload audio brano');
    }
  };

  const saveTrack = async (gid, t) => {
    try {
      // Normalizza prezzo accettando anche stringhe con virgola
      let priceVal = null;
      if (t.price !== undefined && t.price !== null && String(t.price).trim() !== '') {
        if (typeof t.price === 'number' && !Number.isNaN(t.price)) {
          priceVal = t.price;
        } else {
          const parsed = parseFloat(String(t.price).replace(',', '.'));
          priceVal = Number.isFinite(parsed) ? parsed : null;
        }
      }
      await setDoc(doc(db, 'buyGenres', gid, 'tracks', t.id), {
        title: t.title || '',
        order: Number(t.order) || 0,
        audioUrl: t.audioUrl || '',
        paymentLinkUrl: t.paymentLinkUrl || '',
        paypalLinkUrl: t.paypalLinkUrl || '',
        downloadLink: t.downloadLink || '',
        sold: !!t.sold,
        price: priceVal
      }, { merge: true });
      alert('Brano aggiornato');
    } catch (e) {
      console.error('Errore salvataggio brano', e);
      alert('Errore salvataggio brano');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ background: '#111', borderRadius: 12, padding: 16, border: '1px solid #333' }}>
        <h4 style={{ color: '#ffd700', marginTop: 0 }}>Nuovo Genere</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 140px 1fr', gap: 10, alignItems: 'center' }}>
          <input type="text" placeholder="Nome" value={newGenre.name} onChange={e => setNewGenre(g => ({ ...g, name: e.target.value }))} style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <input type="number" placeholder="Ordine" value={newGenre.order} onChange={e => setNewGenre(g => ({ ...g, order: e.target.value }))} style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <input type="text" inputMode="decimal" pattern="[0-9]+([\.,][0-9]{1,2})?" placeholder="Prezzo default (€)" value={newGenre.defaultPrice} onChange={e => setNewGenre(g => ({ ...g, defaultPrice: e.target.value }))} style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <button className="dash-btn dash-btn--primary" onClick={createGenre} disabled={loading}>Crea</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
        {genres.map((g) => (
          <div key={g.id} style={{ background: '#0b0b0b', border: '1px solid #222', borderRadius: 12, padding: 12 }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
              <img src={g.coverUrl || '/logo.png'} alt="cover" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 8 }} />
              <div style={{ display: 'flex', gap: 8, flex: 1, alignItems: 'center' }}>
                <input type="text" value={g.name || ''} onChange={e => setGenres(list => list.map(x => x.id === g.id ? { ...x, name: e.target.value } : x))} placeholder="Nome" style={{ flex: 2, padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
                <input type="number" value={g.order ?? 0} onChange={e => setGenres(list => list.map(x => x.id === g.id ? { ...x, order: e.target.value } : x))} placeholder="Ordine" style={{ width: 120, padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
                <input type="text" inputMode="decimal" pattern="[0-9]+([\.,][0-9]{1,2})?" value={(g.defaultPrice ?? '')} onChange={e => setGenres(list => list.map(x => x.id === g.id ? { ...x, defaultPrice: e.target.value } : x))} placeholder="Prezzo default (€)" style={{ width: 140, padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
                <input id={`cover_${g.id}`} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => uploadGenreCover(e.target.files && e.target.files[0], g.id)} />
                <button className="dash-small-btn dash-small-btn--primary" onClick={() => document.getElementById(`cover_${g.id}`).click()}>Cambia Cover</button>
                <button className="dash-small-btn dash-small-btn--primary" onClick={() => saveGenre(g)}>Salva</button>
                <button className="dash-small-btn dash-small-btn--danger" onClick={() => deleteGenre(g.id)}>Elimina</button>
                <a className="dash-small-btn" href={`/buy/genre/${g.id}`} target="_blank" rel="noreferrer">Apri pubblica</a>
              </div>
            </div>
            <div style={{ marginTop: 10 }}>
              <button className="dash-small-btn" onClick={() => addTrack(g.id, (typeof g.defaultPrice === 'number' && !Number.isNaN(g.defaultPrice)) ? g.defaultPrice : null)}>+ Aggiungi Brano</button>
            </div>
            <GenreTracks gid={g.id} onUploadAudio={uploadTrackAudio} onSaveTrack={saveTrack} />
          </div>
        ))}
      </div>
    </div>
  );
}

function GenreTracks({ gid, onUploadAudio, onSaveTrack }) {
  const [tracks, setTracks] = useState([]);
  useEffect(() => {
    // Legge tutti i brani senza orderBy per includere anche quelli storici senza campi ordine
    const unsub = onSnapshot(collection(db, 'buyGenres', gid, 'tracks'), (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      // Ordina in memoria: order asc, poi createdAt asc, poi title
      list.sort((a, b) => {
        const ao = Number(a.order ?? Number.MAX_SAFE_INTEGER);
        const bo = Number(b.order ?? Number.MAX_SAFE_INTEGER);
        if (ao !== bo) return ao - bo;
        const ac = a.createdAt?.toMillis ? a.createdAt.toMillis() : (a.createdAt?.seconds ? a.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        const bc = b.createdAt?.toMillis ? b.createdAt.toMillis() : (b.createdAt?.seconds ? b.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        if (ac !== bc) return ac - bc;
        return (a.title || '').localeCompare(b.title || '');
      });
      setTracks(list);
    });
    return () => unsub();
  }, [gid]);

  return (
    <div style={{ marginTop: 10, display: 'grid', gridTemplateColumns: '1fr', gap: 8 }}>
      {tracks.map((t) => (
        <div key={t.id} style={{ background: '#111', border: '1px solid #333', borderRadius: 10, padding: 10, display: 'grid', gridTemplateColumns: '2fr 90px 1fr 1.1fr 1.1fr 1fr 160px 120px', gap: 8, alignItems: 'center' }}>
          <input type="text" value={t.title || ''} onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, title: e.target.value } : x))} placeholder="Titolo" style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <input type="number" value={t.order ?? 0} onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, order: e.target.value } : x))} placeholder="Ord." style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff', width: 90 }} />
          <div>
            <input id={`audio_${gid}_${t.id}`} type="file" accept="audio/*" style={{ display: 'none' }} onChange={e => onUploadAudio(gid, t.id, e.target.files && e.target.files[0])} />
            <button className="dash-small-btn dash-small-btn--primary" onClick={() => document.getElementById(`audio_${gid}_${t.id}`).click()}>Audio</button>
            {t.audioUrl ? <a href={t.audioUrl} target="_blank" rel="noreferrer" style={{ color: '#ffd700', marginLeft: 6 }}>Apri</a> : <span style={{ color: '#888', marginLeft: 6 }}>manca</span>}
          </div>
          <input type="url" value={t.paymentLinkUrl || ''} onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, paymentLinkUrl: e.target.value } : x))} placeholder="Stripe Payment Link (URL)" style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <input type="url" value={t.paypalLinkUrl || ''} onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, paypalLinkUrl: e.target.value } : x))} placeholder="PayPal Link (URL)" style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          <div>
            <input type="url" value={t.downloadLink || ''} onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, downloadLink: e.target.value } : x))} placeholder="Link download post-pagamento (opzionale)" style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <input type="text" inputMode="decimal" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" placeholder="Prezzo (€)"
              value={t.price ?? ''}
              onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, price: e.target.value } : x))}
              style={{ padding: 10, borderRadius: 8, border: '1px solid #444', background: '#111', color: '#fff', width: 140 }} />
            <span style={{ marginTop: 4, fontSize: 12, color: '#bbb' }}>
              {(() => { const raw = t.price; if (raw === '' || raw === null || raw === undefined) return 'Anteprima: —'; const num = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(',', '.')); return Number.isFinite(num) ? `Anteprima: € ${num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'Anteprima: —'; })()}
            </span>
          </div>
          <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#ddd', userSelect: 'none' }} title="Stato di disponibilità del brano">
            <input
              type="checkbox"
              checked={!!t.sold}
              onChange={e => setTracks(list => list.map(x => x.id === t.id ? { ...x, sold: e.target.checked } : x))}
            />
            Venduto
          </label>
          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button
              className="dash-small-btn"
              onClick={() => {
                const link = (tracks.find(x => x.id === t.id) || {}).paymentLinkUrl;
                if (link) window.open(link, '_blank', 'noopener,noreferrer');
              }}
              disabled={!((tracks.find(x => x.id === t.id) || {}).paymentLinkUrl)}
              title={((tracks.find(x => x.id === t.id) || {}).paymentLinkUrl) ? 'Apri Payment Link in nuova scheda' : 'Imposta prima il Payment Link'}
            >
              Test Payment Link
            </button>
            <button
              className="dash-small-btn"
              onClick={() => {
                const link = (tracks.find(x => x.id === t.id) || {}).paypalLinkUrl;
                if (link) window.open(link, '_blank', 'noopener,noreferrer');
              }}
              disabled={!((tracks.find(x => x.id === t.id) || {}).paypalLinkUrl)}
              title={((tracks.find(x => x.id === t.id) || {}).paypalLinkUrl) ? 'Apri PayPal in nuova scheda' : 'Imposta prima il link PayPal'}
            >
              Test PayPal
            </button>
            <button className="dash-small-btn dash-small-btn--primary" onClick={() => onSaveTrack(gid, tracks.find(x => x.id === t.id))}>Salva brano</button>
          </div>
        </div>
      ))}
    </div>
  );
}
